import { useId } from 'react'
import './Input.css'
import './Select.css'

export function Select({ label, hint, error, options = [], id, style, ...rest }) {
  const autoId = useId()
  const iid = id || autoId
  const messageId = iid + '-msg'
  const message = error || hint

  return (
    <div
      className="u-field"
      style={{ display: 'flex', flexDirection: 'column', gap: 6, ...style }}
    >
      {label && (
        <label htmlFor={iid} style={{ fontSize: 'var(--text-sm)', fontWeight: 600 }}>
          {label}
        </label>
      )}
      <select
        id={iid}
        className={'u-select' + (error ? ' u-select--error' : '')}
        aria-invalid={error ? true : undefined}
        aria-describedby={message ? messageId : undefined}
        {...rest}
      >
        {options.map((o) =>
          typeof o === 'string' ? (
            <option key={o} value={o}>
              {o}
            </option>
          ) : (
            <option key={o.value} value={o.value}>
              {o.label}
            </option>
          ),
        )}
      </select>
      {message ? (
        <span id={messageId} className={error ? 'u-err' : 'u-hint'}>
          {message}
        </span>
      ) : null}
    </div>
  )
}

export default Select
